export * from "./persona";
export * from "./menu";
export * from "./constants";
export * from "./powerbiConfig";

export const getIndustry = (id: number) => {
  switch (id) {
    case 1:
      return "retail";
    case 2:
      return "manufacturing";
    case 3:
      return "healthcare";
    case 4:
      return "finance";
    default:
      return "retail";
  }
};

export const CONTOSO_COPILOT_WITH_WEBSOCKET =
  "a56472b5-e9f6-432d-ad5d-d18028e39f81";

export const MFG_FABRIC_DEMO = "22bc2820-8b62-484e-a06e-ca5862b4ab03";
export const DEMOS = [
  "bbda1480-8a25-494a-ac9f-12cd26d043f4",
  CONTOSO_COPILOT_WITH_WEBSOCKET,
  "b7ffdc0e-ef2c-4f97-b6a2-e8d4ca2b962a",
  "0e091a2e-1dbb-4296-9818-3db0184ff814",
  "8f107e07-a69b-412a-9c3b-f59002de64c0",
  "c7f22a09-bce5-45f9-b09a-53a6a22497b6",
  MFG_FABRIC_DEMO,
];

export const FSI_DEMOS = [
  "0e091a2e-1dbb-4296-9818-3db0184ff814",
  "8f107e07-a69b-412a-9c3b-f59002de64c0",
  "c7f22a09-bce5-45f9-b09a-53a6a22497b6",
];

export const CONTOSO_COPILOT_PROD = "bbda1480-8a25-494a-ac9f-12cd26d043f4";

export const CONTOSO_COPILOT_WITH_DASH = "9fc02dce-55d7-4e23-8007-58566b55e3a1";

export const CONTOSO_COPILOT_PROD_HARDCODED =
  "8c31a318-0569-47eb-bc6d-15b49abf3f8e";

export const CONTOSO_COPILOT_DEMOS = [
  CONTOSO_COPILOT_PROD,
  CONTOSO_COPILOT_PROD_HARDCODED,
  CONTOSO_COPILOT_WITH_DASH,
  CONTOSO_COPILOT_WITH_WEBSOCKET,
];

export const PG_DEMO = "06db40ee-1bdb-4f34-a666-210fd8c41a5f";
export const EDU_DEMO = "97578192-2520-4d6f-8471-ab89e61d292e";
export const GM_DEMO = "32e1b010-0a95-4d96-a9d3-84a0dfd4a9cc";
export const getIFrameUrl = (guid: string) => {
  switch (guid) {
    case CONTOSO_COPILOT_WITH_DASH:
      return {
        worldMap:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/world-map",
        cityView:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/city-view",
        orgChart:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/contoso-copilot-org-chart",
        ceoDashboardBefore:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/ceo-dashboard-before",
        ceoDashboardAfter:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/ceo-dashboard-after",
        finaleVideo:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/finale-video",
        callCenterBeforeScript:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/call-center-before-script",
        callCenterBeforeSummary:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/call-center-before-summary",
        callCenterAfterScript:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/call-center-after-script",
        callCenterAfterSummary:
          "https://app-contoso-openai-dreamdemo.azurewebsites.net/#/call-center-after-summary",
      };

    default:
      return {
        worldMap: "",
        cityView: "",
        orgChart: "",
        ceoDashboardBefore: "",
        ceoDashboardAfter: "",
        finaleVideo: "",
        callCenterBeforeScript: "",
        callCenterBeforeSummary: "",
        callCenterAfterScript: "",
        callCenterAfterSummary: "",
      };
  }
};
